<template>
  <div class="dashboard-module-header">
    <div>
      <div style="display: flex; align-items: center;">
        <div class="title" style="margin-right: 15px;">
          {{ title }}
          <span v-if="iconQuestion"><i class="el-icon-question"/></span>
        </div>
        <slot/>
      </div>
      <div class="desc">{{ desc }}</div>
    </div>
    <div>
      <slot name="right"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModuleHeader",
  props: {
    title: {
      type: String,
      default() {
        return ""
      }
    },
    desc: {
      type: String,
      default() {
        return ""
      }
    },
    tip: {
      type: String,
      default() {
        return ""
      }
    },
    iconQuestion: {
      type: Boolean,
      default() {
        return true
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.dashboard-module-header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;

  .el-icon-question {
    padding-right: 5px;
    color: #ced5e6;
    font-size: 12px;
    cursor: pointer;
  }

  .title {
    font-size: 16px;
    font-weight: 700;
  }

  .desc {
    color: #8a8e99;
    font-weight: 600;
  }
}
</style>